import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { isSpecialCardSet } from '#src/lib/cardSets.ts';

export const useHasLegacyEssence = () => {
  const { currentUser } = useCurrentUserContext();

  const commonCardShardsChests =
    currentUser?.cardShardsChests?.filter(
      chest => chest.rarity === Rarity.common
    ) || [];
  return commonCardShardsChests.some(
    chest => !isSpecialCardSet(chest.cardSet?.slug) && chest.cardShardsCount > 0
  );
};
